import { AUTH_STATES } from '/b2b/authentication/constants';
import AuthActions from '/b2b/authentication/state/Auth.actions';
import { resetTemporaryPassword as resetTemporaryPasswordService } from '/b2b/authentication/services';

export const resetAuthState = () => dispatch =>
    dispatch(AuthActions.updateAuthState(AUTH_STATES.signedOut));

export const resetTemporaryPassword = email => dispatch => {
    dispatch(AuthActions.resetTemporaryPasswordBegin(email));

    return resetTemporaryPasswordService(email)
        .then(response => {
            return dispatch(AuthActions.resetTemporaryPasswordSuccess(email, response));
        })
        .catch(error => {
            const { message } = error;
            dispatch(AuthActions.resetTemporaryPasswordFailure(email, error));

            throw message;
        });
};
